<template>
  <div class="container">
    <div class="row">
      <div class="col-md-5 mx-auto rounded-3 signup-container">
        <div class="alert alert-warning" role="alert">
          <h6>{{ $t("signup.onlyOnwer") }}</h6>
          <a href="https://www.maika.coffee">{{ $t("signup.backToMaika") }}</a>
        </div>
        <div id="first">
          <div class="myform form ">
            <div class="logo mb-3">
              <div class="col-md-12 text-center">
                <h1>{{ $t("signup.signup") }}</h1>
                <!-- <a href="">How add my café will help my business</a> -->
              </div>
            </div>
            <hr />
            <!-- Success alert -->
            <div class="alert alert-success" role="alert" v-if="isSuccess">
              <font-awesome-icon :icon="['fas', 'check-circle']" />
              <br />
              <b>{{ $t("signup.accountCreated") }}</b>
            </div>

            <div
              class="alert alert-danger"
              role="alert"
              v-if="errorMessage != ''"
            >
              {{ $t(errorMessage) }}
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">{{ $t("signup.email") }}</label>
              <input
                type="email"
                name="email"
                class="form-control"
                id="email"
                aria-describedby="emailHelp"
                placeholder="Enter email"
                v-model="email"
              />
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">{{
                $t("signup.password")
              }}</label>
              <input
                type="password"
                name="password"
                id="password"
                class="form-control"
                aria-describedby="emailHelp"
                placeholder="Enter Password"
                v-model="password"
              />
            </div>
            <div class="form-check signup-terms-check">
              <input
                v-model="termsCondition"
                class="form-check-input"
                type="checkbox"
                id="termsCondition"
              />
              <label class="form-check-label" for="termsCondition">
                {{ $t("signup.agreeTo") }}
                <a :href="`${TERMS_CONDITIONS_URL}`" target="_blank">{{
                  $t("signup.conditions")
                }}</a>
                {{ $t("signup.and") }}
                <a :href="`${PRIVACY_POLICY_URL}`" target="_blank">{{
                  $t("signup.privacy")
                }}</a>
              </label>
            </div>
            <div class="col-md-12 text-center ">
              <button
                :disabled="isCreating"
                @click="signup"
                type="submit"
                class=" btn btn-block mybtn btn-primary tx-tfm signup-button"
              >
                {{ $t("signup.signup") }}
              </button>
              <div
                class="spinner-border doc-upload-spinner signup-creation-spinner"
                role="status"
                v-if="isCreating && !isSuccess"
              ></div>
            </div>
          </div>
        </div>
        <div class="alert alert-primary" role="alert" v-if="!isSuccess">
          {{ $t("signup.alreadyRegistred") }}
          <router-link to="/login">{{ $t("signup.login") }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import router from "@/router";
import OwnerService from "@/services/OwnerService";
const ownerService = new OwnerService();

import { TERMS_CONDITIONS_URL, PRIVACY_POLICY_URL } from "@/const";

export default defineComponent({
  name: "Signup",
  props: {},
  setup(props) {
    console.log("coucou", props);
  },
  methods: {
    // TODO FIRST
    // put in service
    //display error message on view
    async signup() {
      this.errorMessage = "";
      this.isCreating = true;
      console.log("try to signup", this.termsCondition);
      if (this.password == "" || this.email == "" || !this.termsCondition) {
        this.errorMessage = this.$t("signup.fieldsMandatory");
        this.isCreating = false;
        return false;
      }
      if (this.password.length < 8) {
        this.errorMessage = this.$t("signup.passwordShort");
        console.log("pwd too short");
        this.isCreating = false;
        return false;
      }
      const creationAnswder = await ownerService.signupOwner(
        this.email,
        this.password
      );
      console.log("connectionAnswer", creationAnswder);
      if (creationAnswder.success) {
        // alert(this.$t("signup.accountCreated"));
        this.isSuccess = true;
        // window.location.reload();
      } else {
        this.isCreating = false;
        this.errorMessage = creationAnswder.message;
      }
    },
  },
  data() {
    return {
      email: "",
      password: "",
      termsCondition: false,
      errorMessage: "",
      isCreating: false,
      isSuccess: false,
      TERMS_CONDITIONS_URL: TERMS_CONDITIONS_URL,
      PRIVACY_POLICY_URL: PRIVACY_POLICY_URL,
    };
  },
});
</script>

<style></style>
